import SummaryLayout from './SummaryLayout';

export default SummaryLayout;
